import { HierarchyAccessError, id, request, session } from "./api";
import type { TranscriptSelection } from "./transcript";

// Availability is a current UI hint, never a grant or a durable retry receipt.
export async function forkEligibility(selection: TranscriptSelection, nodeId: string, userId: string, signal?: AbortSignal): Promise<boolean> {
  id(selection.accountId); id(selection.workspaceId); id(selection.threadId); id(nodeId); id(userId);
  const before = await session(signal);
  if (before.accountId !== selection.accountId || before.userId !== userId) throw new HierarchyAccessError();
  const path = `/code/workspaces/${encodeURIComponent(selection.workspaceId)}/threads/${encodeURIComponent(selection.threadId)}/turns/${encodeURIComponent(nodeId)}/fork-eligibility`;
  const result = await request(path, signal);
  if (result.accountId !== selection.accountId || result.workspaceId !== selection.workspaceId || result.threadId !== selection.threadId || result.nodeId !== nodeId || typeof result.available !== "boolean") throw new HierarchyAccessError();
  const after = await session(signal);
  if (after.accountId !== before.accountId || after.userId !== before.userId) throw new HierarchyAccessError();
  signal?.throwIfAborted();
  return result.available;
}
